import React from 'react'
import { Helmet } from 'react-helmet'
import { helmetJsonLdProp } from 'react-schemaorg'
import { ContactPoint } from 'schema-dts'

import useUrlPathBuilder from '../../hooks/useUrlPathBuilder'
import { LandingPageV2 } from '../../types/landingPageV2'
import useBrand from '../../hooks/useBrand'
import { LandingPage } from '../../types/landingPage'
import { ReviewPage } from '../../types/review'
import { FAQPage } from '../../types/faq'
import { ProductPage } from '../../types/productPageV2'

interface Props {
  landingPage: LandingPageV2 | LandingPage | FAQPage | ReviewPage | ProductPage
}

const ContactSEO: React.FC<Props> = ({ landingPage }) => {
  const { urlPathBuilder, baseURL } = useUrlPathBuilder()
  const brand = useBrand()

  return (
    <Helmet
      script={[
        helmetJsonLdProp<ContactPoint>({
          '@context': 'https://schema.org',
          '@type': 'ContactPoint',
          telephone: brand.default_phone_number,
          contactType: 'Support',
          email: brand.default_support_email,
          hoursAvailable: {
            '@type': 'OpeningHoursSpecification',
            '@id': urlPathBuilder([landingPage.slug], {
              baseURL,
              hash: 'OpeningHoursSpecification',
            }),
            dayOfWeek: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday'],
            opens: brand.name === 'TopCV' ? '07:00' : '09:00',
            closes: brand.name === 'TopCV' ? '16:00' : '19:00',
          },
        }),
      ]}
    />
  )
}

export default ContactSEO
